<!-- Cards list -->
<ul class="payment-option__list" 
	role="radiogroup"
	attr.aria-label="{{'shoppingBasket.aria.selectSavedCard' | ibeadmin | async}}"
	*ngIf="logged_in && type != 'bancontact'">
	<li class="payment-option__item" *ngFor="let card of availableCards">
		<div class="left">
			<app-radio-input 
				class="payment-option-radio" 
				(change)="INDRA_selectCard(card)" 
				[selected]="INDRA_isSelectCard(card)"
				role="radio" 
				[attr.aria-checked]="INDRA_isSelectCard(card)" 
				[attr.aria-label]="INDRA_printCardAriaLabel(card)">
			</app-radio-input>
			<app-svg 
				svg="sprite.svg#{{ cardBrands.get(card.brand)?.image }}" 
				class="payment-option-card-image"
				aria-hidden="true" 
				[alt]="cardBrands.get(card.brand)?.name + ' logo'">
			</app-svg>
			<div aria-hidden="true">
				<p class="payment-option-item-label">
					{{ cardBrands.get(card.brand)?.name }}
				</p>
				<span class="payment-option-item-description">
					{{ 'Ending in ' + INDRA_printNumberEnding(card) }}
				</span>
			</div>
		</div>

		<div class="right">
			<a *ngIf="card.status === 'expired'" 
				class="link" (click)="INDRA_selectCard(card)" 
				href="javascript:;" 
				role="button"
				attr.aria-label="{{'bookingPayment.text.updateThe' | ibeadmin | async }} {{ cardBrands.get(card.brand)?.name }} {{ 'bookingPayment.text.cardEndingIn' | ibeadmin | async }} {{INDRA_printNumberEnding(card)}}">
				{{ 'bookingPayment.text.updateCard' | ibeadmin | async }}
			</a>
			<a class="link" 
				(click)="INDRA_deleteCard(card)" 
				href="javascript:;" 
				role="button"
				attr.aria-label="{{'shoppingBasket.text.deleteThe' | ibeadmin | async}} {{ cardBrands.get(card.brand)?.name }} {{'shoppingBasket.text.cardEndingIn' | ibeadmin | async}} {{INDRA_printNumberEnding(card)}}">
				{{'shoppingBasket.text.deleteCard' | ibeadmin | async}}
			</a>
			<span aria-hidden="true" *ngIf="card.status === 'available'" class="payment-option-item-date">
				{{ 'bookingPayment.text.expires' | ibeadmin | async }} <span class="bold"> {{ card.expire_date}}</span>
			</span>
			<span *ngIf="card.status === 'expired'" class="payment-option-item-date is-expired" aria-hidden="true">
				{{ 'bookingPayment.text.expired' | ibeadmin | async }}
			</span>
		</div>
	</li>

	<li class="payment-option__item" *ngIf="availableCards.length">
		<div class="left">
			<app-radio-input class="payment-option-radio" 
				(change)="INDRA_selectCard()" 
				role="radio"
				[selected]="INDRA_isSelectedCardStatus('other')"
				[attr.aria-checked]="INDRA_isSelectCard()" 
				attr.aria-label="{{'shoppingBasket.text.useOtherCard' | ibeadmin | async}}">
			</app-radio-input>
			<div aria-hidden="true">
				<p class="payment-option-item-label">{{'shoppingBasket.text.useOtherCard' | ibeadmin | async}}</p>
			</div>
		</div>
	</li>
</ul>

<!-- Available saved card -->
<ng-container *ngIf="INDRA_isSelectedCardStatus('available') && type != 'bancontact'">
	<h3 class="title-h3">{{'shoppingBasket.title.paymentSavedCard' | ibeadmin | async}}</h3>
	<p class="muted" *ngIf="!cardWithoutCvc">{{'shoppingBasket.text.insertCvv' | ibeadmin | async}}</p>
	
	<app-notification class="cc-surcharge-notification" [style]="'note'" [icon]="'icons.svg#general--information'" *ngIf="(type === 'credit') && surchargeDisplay > 0">
		<div message>
			<span>
				{{ 'bookingPayment.text.creditCardSurchargeMsg1' | ibeadmin | async }} {{surchargeDisplay}}% {{ 'bookingPayment.text.creditCardSurchargeMsg2' | ibeadmin | async }} 
			</span>
		</div>
	</app-notification>
	
	<form [formGroup]="formAvailableCard">
		
		<ng-container *ngIf="isBrazilMarket && hasInstallmentConfig && !isTTT">
			<fieldset *ngIf="type === 'credit'">
				<legend class="visuallyhidden">{{ 'bookingPayment.text.paymentInstallment' | ibeadmin | async }}</legend>
				<div class="form-field--row grid no-padding">
					<div class="form-field col-5 col-tp-5 col-p-12">
						<label class="label" for="pay_with_instalments" id="pay_with_instalments-label">
							{{ 'bookingPayment.text.willYouPayInstallment' | ibeadmin | async }}
						</label>
						<p>{{ 'bookingPayment.text.payForYourServices' | ibeadmin | async }} {{ installmentCount }} {{ 'bookingPayment.text.ineterestFreeInstallment' | ibeadmin | async }}</p>
						<app-radio-input-group-indra 
							role="radiogroup" 
							aria-labelledby="pay_with_instalments-label" 
							[inline]="true"
							formControlName="pay_with_instalments" 
							(optionChanged)="INDRA_changePayWithInstallments($event)"
							name="pay_with_instalments" 
							[options]="payWithInstallmentOptions">
						</app-radio-input-group-indra>
					</div>
				</div>
			</fieldset>
			<!-- Installments -->
			<fieldset *ngIf="payWithInstalments">
				<legend class="visuallyhidden">
					{{ 'bookingPayment.text.paymentWithInstallment' | ibeadmin | async }} 
				</legend>
				<div class="form-field--row grid no-padding">
					<div class="form-field col-6 col-p12">
						<label class="label" for="instalments_option">
							{{ 'bookingPayment.text.installments' | ibeadmin | async }}  
						</label>
						<app-select-input-indra
							selectId="instalments_option"
							formControlName="instalments_option"
							[placeholder]="!(formAvailableCard.get('instalments_option').text) ? ('bookingPayment.text.selectPayments' | ibeadmin | async) : null"
							[options]="INDRA_getInstallmentsOptions()"
							[optionsTranslated]="false"
							[isValueComplexObject]="true"
							[errorClass]="INDRA_hasErrorsClasses(formAvailableCard.get('instalments_option'))"
						></app-select-input-indra>
						<span aria-live="polite" class="input-error" role="alert"
							*ngIf="INDRA_hasErrors(formAvailableCard.get('instalments_option'))">
							{{ INDRA_formErrors(formAvailableCard.get('instalments_option'), 'instalments_option') | ibeadmin | async }}
						</span>
						<!-- Installments details text  -->
						<!-- <p class="installment-details">{{ INDRA_printInstallmentOption(formAvailableCard.get('instalments_option').value) }}</p> -->
					</div>
					<div class="form-field col-6 col-p12">
						<label class="label" for="instalments_cpf">
							CPF
						</label>
						<input [placeholder]="'bookingPayment.text.insertCPF' | ibeadmin | async" 
							appNumberOnly 
							pattern="\d*" 
							size="11" 
							maxlength="11" 
							class="input-text"
							formControlName="instalments_cpf" 
							id="instalments_cpf" 
							[ngClass]="INDRA_hasErrorsClasses(formAvailableCard.get('instalments_cpf'))" />
						<span aria-live="polite" class="input-error" role="alert"
							*ngIf="INDRA_hasErrors(formAvailableCard.get('instalments_cpf'))">
							{{ INDRA_formErrors(formAvailableCard.get('instalments_cpf'), 'instalments_cpf') | ibeadmin | async }}
						</span>
					</div>
				</div>
			</fieldset>
		</ng-container>
		
		<div class="form-field--row grid no-padding" *ngIf="!cardWithoutCvc">
			<div class="form-field col-4 col-tp-8 col-p-12">
				<label class="label" for="security_code">
					{{'shoppingBasket.text.securityCode' | ibeadmin | async}}
					<app-svg 
						tooltip="{{'shoppingBasket.tooltip.securityCodeTooltip' | ibeadmin | async}}" 
						svg="icons.svg#general--information" 
						[alt]="'bookingPayment.alt.informationIcon' | ibeadmin | async">
					</app-svg>
				</label>
				<div class="grid">
					<div class="col-5">
						<input class="input-text" 
							formControlName="security_code" 
							id="security_code"
							inputmode="numeric" 
							type="text"  
							[ngClass]="INDRA_hasErrorsClasses(formAvailableCard.get('security_code'))" 
							pattern="\d*" size="4" maxlength="4" appNumberOnly />
					</div>
					<div class="col-7">
						<div class="payment-option-security-code-image__wrapper">
							<app-svg 
								svg="sprite.svg#credit_card--security_code_info" 
								class="payment-option-security-code-image"
								[alt]="'bookingPayment.alt.cardSecurityCode' | ibeadmin | async">
							</app-svg>
						</div>
					</div>
				</div>
				<span aria-live="polite" class="input-error" role="alert"
					*ngIf="INDRA_hasErrors(formAvailableCard.get('security_code'))">
					{{ INDRA_formErrors(formAvailableCard.get('security_code'),'security_code') | ibeadmin | async }}
				</span>
			</div>
		</div>
		<div class="form-field--row grid no-padding">
			<div class="form-field col-12 payment-option__conditions-wrapper" [class.has-error]="!acceptedTermsAndConditions">
				<ng-container *ngIf="hasHotelRoom && type === 'credit'">
					<div class="payment-option__conditions bottom-gap">
						<app-checkbox-input 
							[label]="''" 
							formControlName="accepted_send_user_info"
							(change)="INDRA_acceptedHotelConditionChange('acceptedHotelConditionAvailable')" 
							[checked]="acceptedHotelConditionAvailable"
							[class.has-error]="INDRA_hasErrors(formAvailableCard.get('accepted_send_user_info'))">
						</app-checkbox-input>
						<span>
							{{ 'bookingPayment.text.iUnderstand' | ibeadmin | async }}
						</span>
					</div>
					<span aria-live="polite" class="input-error display--block" role="alert"
						*ngIf="INDRA_hasErrors(formAvailableCard.get('accepted_send_user_info'))">
						{{ INDRA_formErrors(formAvailableCard.get('accepted_send_user_info'), 'accepted_send_user_info') | ibeadmin | async }}
					</span>
				</ng-container>
				<div class="payment-option__conditions">
					<app-checkbox-input 
						[label]="''" 
						formControlName="accepted_conditions"
						(change)="INDRA_acceptedConditionChange($event, 'acceptedConditionAvailable')" 
						[checked]="acceptedConditionAvailable"
						[class.has-error]="INDRA_hasErrors(formAvailableCard.get('accepted_conditions'))">
					</app-checkbox-input>
					<span>
						{{'shoppingBasket.text.fullAndAccept' | ibeadmin | async}} 
						<a class="link" href="javascript:;" 
							(click)="INDRA_handleBookingTicketConditions()" 
							[attr.aria-label]="'bookingPayment.aria.openFare' | ibeadmin | async" role="button">
							{{'shoppingBasket.text.fareCondition' | ibeadmin | async}}
						</a> 
						{{ 'bookingPayment.text.andThe' | ibeadmin | async }}
						<a class="link link--external" href="javascript:;"
							(click)="INDRA_gotoURL('externalURLs.transportConditions')"
							[attr.aria-label]="'bookingPayment.text.conditionsOfCarriage' | ibeadmin | async">
							{{'shoppingBasket.text.termsConditionCarriage' | ibeadmin | async}}
						</a> 
						<!--{{ 'bookingPayment.text.andThe' | ibeadmin | async }}
						<a class="link link--external" href="javascript:;"
							(click)="INDRA_gotoURL('externalURLs.milesGoTermsConditions')">
							{{ 'bookingPayment.text.conditionsOfMilesGoProgramme' | ibeadmin | async }}
						</a>-->
						<ng-container *ngIf="displayCovidTermsAndCondition">
							, {{ 'bookingPayment.text.andAcceptCovidCondition' | ibeadmin | async }}
							<a class="link link--external" href="javascript:;"
								(click)="INDRA_gotoURL('externalURLs.canadaTravelMeasures')">
								{{ 'bookingPayment.text.termsConditions' | ibeadmin | async }}
							</a>
							{{ 'bookingPayment.text.covidCondition' | ibeadmin | async }}
						</ng-container>
					</span>
				</div>
				<span aria-live="polite" class="input-error display--block" role="alert"
					*ngIf="INDRA_hasErrors(formAvailableCard.get('accepted_conditions'))">
					{{ INDRA_formErrors(formAvailableCard.get('accepted_conditions'),'accepted_conditions') | ibeadmin | async }}
				</span>
			</div>
		</div>
	</form>
</ng-container>

<!-- Expired saved card -->
<ng-container *ngIf="INDRA_isSelectedCardStatus('expired') && type != 'bancontact'">
	<app-notification [classes]="'top-gap'" [style]="'error'" 
		[title]="'The card ' + INDRA_printNumberEnding(selectedCard) + ' has expired.'">
		<div message>
			{{ 'shoppingBasket.text.updateCardDetailsMessage' | ibeadmin | async }}
		</div>
	</app-notification>

	<h3 class="title-h3">
		{{ 'shoppingBasket.title.updateCardDetails' | ibeadmin | async }}
	</h3>
	<p class="muted">
		{{ 'shoppingBasket.text.insertNewCard' | ibeadmin | async }}
		<a class="link" 
			(click)="INDRA_deleteCard(selectedCard)" 
			href="javascript:;" 
			role="button"
			attr.aria-label="Delete the { cardBrands.get(selectedCard.brand).name }} card ending in {{INDRA_printNumberEnding(selectedCard)}}">
			{{ 'shoppingBasket.text.deleteCard' | ibeadmin | async }}
		</a>.
	</p>
	
	<app-notification class="cc-surcharge-notification" [style]="'note'" [icon]="'icons.svg#general--information'" *ngIf="(type === 'credit') && surchargeDisplay > 0">
		<div message>
			<span>
				{{ 'bookingPayment.text.creditCardSurchargeMsg1' | ibeadmin | async }} {{surchargeDisplay}}% {{ 'bookingPayment.text.creditCardSurchargeMsg2' | ibeadmin | async }} 
			</span>
		</div>
	</app-notification>
		
	<form [formGroup]="formExpiredCard">
		<div class="form-field--row grid no-padding">
			<div class="form-field col-5 col-tp-6 col-p-12">
				<label class="label" for="card_number">
					{{ 'shoppingBasket.text.cardNumber' | ibeadmin | async }}
					<span class="description">
						{{ 'shoppingBasket.text.longNumber' | ibeadmin | async }}
					</span>
				</label>
				<input 
					[placeholder]="'shoppingBasket.text.insertCreditCard' | ibeadmin | async"
					class="input-text" 
					formControlName="card_number" 
					id="card_number"
					type="text"
					inputmode="numeric"  
					[ngClass]="INDRA_hasErrorsClasses(formExpiredCard.get('card_number'))" 
					size="19"
					maxlength="19"
					(blur)="INDRA_trimFieldValue($event, formExpiredCard.get('card_number'))"
					[appNumberOnly]="'ext'" />
				<span aria-live="polite" class="input-error" role="alert"
					*ngIf="INDRA_hasErrors(formExpiredCard.get('card_number'))">
					{{ INDRA_formErrors(formExpiredCard.get('card_number'), 'card_number') | ibeadmin | async }}
				</span>
			</div>
			<div class="form-field col-4 col-tp-6 col-p-12" *ngIf="!cardWithoutCvc">
				<label class="label" for="security_code">
					{{ 'shoppingBasket.text.securityCode' | ibeadmin | async }}
					<app-svg 
						tooltip="{{'shoppingBasket.tooltip.securityCodeTooltip' | ibeadmin | async}}" 
						svg="icons.svg#general--information" 
						[alt]="'bookingPayment.alt.informationIcon' | ibeadmin | async">
					</app-svg>
				</label>
				<div class="grid">
					<div class="col-5">
						<input type="text" 
							class="input-text" 
							formControlName="security_code" 
							id="security_code" 
							inputmode="numeric" 
							pattern="[0-9]*"
							[ngClass]="INDRA_hasErrorsClasses(formExpiredCard.get('security_code'))" 
							pattern="\d*" size="4" maxlength="4" appNumberOnly />
					</div>
					<div class="col-7">
						<div class="payment-option-security-code-image__wrapper">
							<app-svg 
								svg="sprite.svg#credit_card--security_code_info" 
								class="payment-option-security-code-image"
								[alt]="'bookingPayment.alt.cardSecurityCode' | ibeadmin | async">
							</app-svg>
						</div>
					</div>
				</div>
				<span aria-live="polite" class="input-error" role="alert"
					*ngIf="INDRA_hasErrors(formExpiredCard.get('security_code'))">
					{{ INDRA_formErrors(formExpiredCard.get('security_code'), 'security_code') | ibeadmin | async }}
				</span>
			</div>
		</div>
		<div class="form-field--row grid no-padding">
			<div class="form-field col-3 col-tp-6 col-p-12">
				<label class="label" for="expiration_date_month">
					{{ 'shoppingBasket.text.expirationDate' | ibeadmin | async }}
				</label>
				<div class="grid">
					<div class="col-6">
						<app-select-input-indra
							selectId="expiration_date_month--expired-card"
							formControlName="expiration_date_month"
							[placeholder]="!(formExpiredCard.get('expiration_date_month').value) ? 'mm' : null"
							[options]="intervalMonth"
							[optionsTranslated]="true"
							[errorClass]="INDRA_hasErrorsClasses(formExpiredCard.get('expiration_date_month'))"
							(change)="INDRA_formChanges('expiredForm_month')" >
						</app-select-input-indra>
					</div>
					<div class="col-6">
						<app-select-input-indra
							selectId="expiration_date_year--expired-card"
							formControlName="expiration_date_year"
							[placeholder]="!(formExpiredCard.get('expiration_date_year').value) ? 'yy' : null"
							[options]="intervalYear"
							[optionsTranslated]="true"
							[errorClass]="INDRA_hasErrorsClasses(formExpiredCard.get('expiration_date_year'))"
							(change)="INDRA_formChanges('expiredForm_year')">
						</app-select-input-indra>
					</div>
				</div>
				<span aria-live="polite" class="input-error" role="alert"
					*ngIf="INDRA_hasErrors(formExpiredCard.get('expiration_date_month'))">
					{{ INDRA_formErrors(formExpiredCard.get('expiration_date_month'), 'expiration_date_month') | ibeadmin | async }}
				</span>
				<span aria-live="polite" class="input-error" role="alert"
					*ngIf="INDRA_hasErrors(formExpiredCard.get('expiration_date_year'))">
					{{ INDRA_formErrors(formExpiredCard.get('expiration_date_year'), 'expiration_date_year') | ibeadmin | async }}
				</span>
			</div>
		</div>
		<div class="form-field--row grid no-padding">
			<div class="form-field col-12 payment-option__conditions-wrapper" [class.has-error]="!acceptedTermsAndConditions">
				<ng-container *ngIf="hasHotelRoom && type === 'credit'">
					<div class="payment-option__conditions bottom-gap">
						<app-checkbox-input 
							[label]="''" 
							formControlName="accepted_send_user_info"
							(change)="INDRA_acceptedHotelConditionChange('acceptedHotelConditionExpired')"
							[checked]="acceptedHotelConditionExpired" 
							[class.has-error]="INDRA_hasErrors(formExpiredCard.get('accepted_send_user_info'))">
						</app-checkbox-input>
						<span>
							{{ 'bookingPayment.text.iUnderstand' | ibeadmin | async }}
						</span>
					</div>
					<span aria-live="polite" class="input-error display--block" role="alert"
						*ngIf="INDRA_hasErrors(formExpiredCard.get('accepted_send_user_info'))">
						{{ INDRA_formErrors(formExpiredCard.get('accepted_send_user_info'), 'accepted_send_user_info') | ibeadmin | async }}
					</span>
				</ng-container>
				<div class="payment-option__conditions">
					<app-checkbox-input 
						[label]="''" 
						formControlName="accepted_conditions"  
						(change)="INDRA_acceptedConditionChange($event, 'acceptedConditionExpired')" 
						[checked]="acceptedConditionExpired"
						[class.has-error]="INDRA_hasErrors(formExpiredCard.get('accepted_conditions'))">
					</app-checkbox-input>
					<span>
						{{ 'shoppingBasket.text.fullAndAccept' | ibeadmin | async }} 
						<a class="link" href="javascript:;" 
							(click)="INDRA_handleBookingTicketConditions()" 
							aria-label="'Open fare Conditions details'" role="button">
							{{ 'shoppingBasket.text.fareCondition' | ibeadmin | async }}
						</a> 
						{{ 'bookingPayment.text.andThe' | ibeadmin | async }}
						<a class="link link--external" href="javascript:;"
							(click)="INDRA_gotoURL('externalURLs.transportConditions')"
							[attr.aria-label]="'bookingPayment.text.conditionsOfCarriage' | ibeadmin | async">
							{{ 'shoppingBasket.text.termsConditionCarriage' | ibeadmin | async }}
						</a> 
						<!--{{ 'bookingPayment.text.andThe' | ibeadmin | async }}
						<a class="link link--external" href="javascript:;"
							(click)="INDRA_gotoURL('externalURLs.milesGoTermsConditions')">
							{{ 'bookingPayment.text.conditionsOfMilesGoProgramme' | ibeadmin | async }}
						</a>-->
						<ng-container *ngIf="displayCovidTermsAndCondition">
							, {{ 'bookingPayment.text.andAcceptCovidCondition' | ibeadmin | async }}
							<a class="link link--external" href="javascript:;"
								(click)="INDRA_gotoURL('externalURLs.canadaTravelMeasures')">
								{{ 'bookingPayment.text.termsConditions' | ibeadmin | async }}
							</a>
							{{ 'bookingPayment.text.covidCondition' | ibeadmin | async }}
						</ng-container>
					</span>
				</div>
				<span aria-live="polite" class="input-error display--block" role="alert"
					*ngIf="INDRA_hasErrors(formExpiredCard.get('accepted_conditions'))">
					{{ INDRA_formErrors(formExpiredCard.get('accepted_conditions'),'accepted_conditions') | ibeadmin | async }}
				</span>
			</div>
		</div>
	</form>
</ng-container>

<div *ngIf="alertMethodsPayment">
	<app-notification [classes]="'top-gap'" [style]="'alert'" [title]="'bookingPayment.title.paymentMethodNotAvail' | ibeadmin | async">
		<div message>
			{{ 'shoppingBasket.text.paymentMethodsNotAvailable' | ibeadmin | async }}
		</div>
	</app-notification>
</div>

<!-- Use other card -->
<ng-container *ngIf="INDRA_isSelectedCardStatus('other') || type === 'bancontact'">
	<h3 class="title-h3">
		{{ INDRA_printTitle() }}
	</h3>

	<app-notification class="cc-surcharge-notification" [style]="'note'" [icon]="'icons.svg#general--information'" *ngIf="(type === 'credit') && surchargeDisplay > 0">
		<div message>
			<span>
				{{ 'bookingPayment.text.creditCardSurchargeMsg1' | ibeadmin | async }} {{surchargeDisplay}}% {{ 'bookingPayment.text.creditCardSurchargeMsg2' | ibeadmin | async }} 
			</span>
		</div>
	</app-notification>

	<form [formGroup]="formOtherCard">
		
		<!--
		<ng-container *ngIf="isBrazilMarket && hasInstallmentConfig && !isTTT && !bookAwardFlights">
			<fieldset *ngIf="type === 'credit'">
				<legend class="visuallyhidden">{{ 'bookingPayment.text.paymentInstallment' | ibeadmin | async }}</legend>
				<div class="form-field--row grid no-padding">
					<div class="form-field col-5 col-tp-5 col-p-12">
						<label class="label" for="pay_with_instalments" id="pay_with_instalments-label">
							{{ 'bookingPayment.text.willYouPayInstallment' | ibeadmin | async }}
						</label>
						<p>{{ 'bookingPayment.text.payForYourServices' | ibeadmin | async }} {{ installmentCount }} {{ 'bookingPayment.text.ineterestFreeInstallment' | ibeadmin | async }}</p>
						<app-radio-input-group-indra 
							role="radiogroup" 
							aria-labelledby="pay_with_instalments-label" 
							[inline]="true"
							formControlName="pay_with_instalments" 
							(optionChanged)="INDRA_changePayWithInstallments($event)"
							name="pay_with_instalments" 
							[options]="payWithInstallmentOptions">
						</app-radio-input-group-indra>
					</div>
				</div>
			</fieldset>
			
			<fieldset *ngIf="payWithInstalments">
				<legend class="visuallyhidden">
					{{ 'bookingPayment.text.paymentWithInstallment' | ibeadmin | async }} 
				</legend>
				<div class="form-field--row grid no-padding">
					<div class="form-field col-6 col-p12">
						<label class="label" for="instalments_option">
							{{ 'bookingPayment.text.installments' | ibeadmin | async }}  
						</label>
						<div class="select-wrapper">
							<span class="select-placeholder" *ngIf="!formOtherCard.get('instalments_option').value">
								{{ 'bookingPayment.text.selectPayments' | ibeadmin | async }}   
							</span>
							<app-select-input-indra
								selectId="instalments_option"
								formControlName="instalments_option"
								[placeholder]="!(formOtherCard.get('instalments_option').text) ? ('bookingPayment.text.selectPayments' | ibeadmin | async) : null"
								[options]="INDRA_getInstallmentsOptions()"
								[optionsTranslated]="false"
								[isValueComplexObject]="true"
								[errorClass]="INDRA_hasErrorsClasses(formOtherCard.get('instalments_option'))"
							></app-select-input-indra>
						</div>
						<span aria-live="polite" class="input-error" role="alert"
							*ngIf="INDRA_hasErrors(formOtherCard.get('instalments_option'))">
							{{ INDRA_formErrors(formOtherCard.get('instalments_option'), 'instalments_option') | ibeadmin | async }}
						</span>
					</div>
					<div class="form-field col-6 col-p12">
						<label class="label" for="instalments_cpf">
							CPF
						</label>
						<input [placeholder]="'bookingPayment.text.insertCPF' | ibeadmin | async" 
							appNumberOnly 
							pattern="\d*" 
							size="11" 
							maxlength="11" 
							class="input-text"
							formControlName="instalments_cpf" 
							id="instalments_cpf" 
							[ngClass]="INDRA_hasErrorsClasses(formOtherCard.get('instalments_cpf'))" />
						<span aria-live="polite" class="input-error" role="alert"
							*ngIf="INDRA_hasErrors(formOtherCard.get('instalments_cpf'))">
							{{ INDRA_formErrors(formOtherCard.get('instalments_cpf'), 'instalments_cpf') | ibeadmin | async }}
						</span>
					</div>
				</div>
			</fieldset>
		</ng-container>
		-->

		<!-- The cardholder will travel -->
		<fieldset>
			<hr class="separator separator--muted top-gap" />
			<legend class="visuallyhidden">
				{{ 'bookingPayment.text.paymentWithCCInfo' | ibeadmin | async }}    
			</legend>
			<div class="form-field--row grid no-padding">
				<div class="form-field col-5 col-tp-5 col-p-12">
					<label class="label" for="cardholder_will_travel" id="cardholder_will_travel-label">
						{{ 'shoppingBasket.text.cardHolderTravel' | ibeadmin | async }}
					</label>
					<app-radio-input-group-indra 
						#checkboxTravel
						role="radiogroup" 
						aria-labelledby="cardholder_will_travel-label" 
						[inline]="true"
						formControlName="cardholder_will_travel" 
						name="cardholder_will_travel"
						(optionChanged)="INDRA_changedCheckBoxTravel($event)"
						[options]="cardHolderTravelOptions">
					</app-radio-input-group-indra>
					<span aria-live="polite" class="input-error" role="alert" 
						*ngIf="INDRA_hasErrors(formOtherCard.get('cardholder_will_travel'))">
						{{ INDRA_formErrors(formOtherCard.get('cardholder_will_travel'), 'cardholder_will_travel') | ibeadmin | async }}
					</span>
				</div>
			</div>
		</fieldset>

		<!-- <fieldset *ngIf="cardholderWillTravel !== null"> -->
		<fieldset>
			<legend class="visuallyhidden">
				{{ 'shoppingBasket.text.paymentWithCardData' | ibeadmin | async }}
			</legend>
			<!-- TODO implement this (from sprint 8 merge)
			<div class="form-field--row grid no-padding">
				<div class="form-field col-6 col-tp-6 col-p-12">
					<label class="label" for="name_on_card">Name on card</label>
					<input 
						placeholder="Insert name on card" 
						class="input-text" 
						formControlName="name_on_card" 
						id="name_on_card"
						(keyup)="INDRA_formChanges()" 
						[ngClass]="INDRA_hasErrorsClasses(formOtherCard.get('name_on_card'))" />
					<span aria-live="polite" class="input-error" role="alert"
						*ngIf="INDRA_hasErrors(formOtherCard.get('name_on_card'))">{{
							INDRA_hasErrors(formOtherCard.get('name_on_card'), 'name_on_card')
						}}</span>
				</div>
			</div>
			-->
			
			<div class="form-field--row grid no-padding" *ngIf="type != 'bancontact'">
				<div class="form-field col-6 col-tp-6 col-p-12 payment-card-types-wrapper">
					<label class="label" for="card_brand" id="card_brand-label">
						{{ 'shoppingBasket.text.selectCardType' | ibeadmin | async }}
					</label>
					<!--
					<app-radio-input-card-group 
						role="radiogroup" 
						aria-labelledby="card_brand-label" 
						[inline]="true"
						formControlName="card_brand" 
						name="card_brand" 
						[options]="availableCardBrandOptions" 
						*ngIf="!isMobile && !isIE" 
						(change)="INDRA_formChanges('cardChange')">
					</app-radio-input-card-group>
					-->

					<div class="select-wrapper" [ngClass]="{'select-wrapper--card-types' : activeCardType}" *ngIf="isMobile || isIE || !isMobile && !isIE">
						<app-svg
							*ngIf="activeCardType"
							class="select-card-type"
							svg="sprite.svg#{{ INDRA_selectedCard(activeCardType)?.image }}" 
							aria-hidden="true" 
							[alt]="INDRA_selectedCard(activeCardType)?.label + ' logo'">
						</app-svg>
						<span class="select-placeholder" aria-hidden="true" *ngIf="!activeCardType">
							{{ 'bookingPayment.text.selectTheCardType' | ibeadmin | async }}
						</span>
						<select selectbox required id="card_brand" 
							formControlName="card_brand" 
							class="select" 
							(change)="INDRA_formChanges('cardChange')" 
							[ngClass]="INDRA_hasErrorsClasses(formOtherCard.get('card_brand'))">
							<option
								*ngFor="let card of availableCardBrandOptions; trackBy: trackByFn"
								value="{{ card.id }}">
								{{ card.label }}
							</option>
						</select>
					</div>

					<span aria-live="polite" class="input-error" role="alert" 
						*ngIf="INDRA_hasErrors(formOtherCard.get('card_brand'))">
						{{ INDRA_formErrors(formOtherCard.get('card_brand'), 'card_brand') | ibeadmin | async }}
					</span>
				</div>
			</div>
			
			<!-- Installments -->
			<ng-container *ngIf="isBrazilMarket && hasInstallmentConfig && !isTTT">
				<ng-container *ngIf="type === 'credit'">
					<legend class="visuallyhidden">{{ 'bookingPayment.text.paymentInstallment' | ibeadmin | async }}</legend>
					<div class="form-field--row grid no-padding">
						<div class="form-field col-5 col-tp-5 col-p-12">
							<label class="label" for="pay_with_instalments" id="pay_with_instalments-label">
								{{ 'bookingPayment.text.willYouPayInstallment' | ibeadmin | async }}
							</label>
							<p>{{ 'bookingPayment.text.payForYourServices' | ibeadmin | async }} {{ installmentCount }} {{ 'bookingPayment.text.ineterestFreeInstallment' | ibeadmin | async }}</p>
							<app-radio-input-group-indra 
								role="radiogroup" 
								aria-labelledby="pay_with_instalments-label" 
								[inline]="true"
								formControlName="pay_with_instalments" 
								(optionChanged)="INDRA_changePayWithInstallments($event)"
								name="pay_with_instalments" 
								[options]="payWithInstallmentOptions">
							</app-radio-input-group-indra>
						</div>
					</div>
				</ng-container>
				<ng-container *ngIf="payWithInstalments">
					<legend class="visuallyhidden">
						{{ 'bookingPayment.text.paymentWithInstallment' | ibeadmin | async }} 
					</legend>
					<div class="form-field--row grid no-padding">
						<div class="form-field col-6 col-p12">
							<label class="label" for="instalments_option">
								{{ 'bookingPayment.text.installments' | ibeadmin | async }}  
							</label>
							<app-select-input-indra
								selectId="instalments_option"
								formControlName="instalments_option"
								[placeholder]="!(formOtherCard.get('instalments_option').text) ? ('bookingPayment.text.selectPayments' | ibeadmin | async) : null"
								[options]="INDRA_getInstallmentsOptions()"
								[optionsTranslated]="false"
								[isValueComplexObject]="true"
								[errorClass]="INDRA_hasErrorsClasses(formOtherCard.get('instalments_option'))"
							></app-select-input-indra>
							<span aria-live="polite" class="input-error" role="alert"
								*ngIf="INDRA_hasErrors(formOtherCard.get('instalments_option'))">
								{{ INDRA_formErrors(formOtherCard.get('instalments_option'), 'instalments_option') | ibeadmin | async }}
							</span>
							<!-- Installments details text  -->
							<!-- <p class="installment-details">{{ INDRA_printInstallmentOption(formOtherCard.get('instalments_option').value) }}</p> -->
						</div>
						<div class="form-field col-6 col-p12">
							<label class="label" for="instalments_cpf">
								CPF
							</label>
							<input [placeholder]="'bookingPayment.text.insertCPF' | ibeadmin | async" 
								appNumberOnly 
								pattern="\d*" 
								size="11" 
								maxlength="11" 
								class="input-text"
								formControlName="instalments_cpf" 
								id="instalments_cpf" 
								[ngClass]="INDRA_hasErrorsClasses(formOtherCard.get('instalments_cpf'))" />
							<span aria-live="polite" class="input-error" role="alert"
								*ngIf="INDRA_hasErrors(formOtherCard.get('instalments_cpf'))">
								{{ INDRA_formErrors(formOtherCard.get('instalments_cpf'), 'instalments_cpf') | ibeadmin | async }}
							</span>
						</div>
					</div>
				</ng-container>
			</ng-container>
			
			<div class="form-field--row grid no-padding">
				<div class="form-field col-4 col-tp-6 col-p-12">
					<label class="label" for="first_name">
						{{ 'shoppingBasket.text.firstName' | ibeadmin | async }}
						<span class="description">
							{{ 'shoppingBasket.text.asAppearsOnCard' | ibeadmin | async }}
						</span>
					</label>
					<input 
						[placeholder]="'shoppingBasket.text.insertFirstName' | ibeadmin | async" 
						class="input-text" 
						formControlName="first_name" 
						id="first_name"
						[ngClass]="INDRA_hasErrorsClasses(formOtherCard.get('first_name'))" 
						maxlength="32"/>
					<span aria-live="polite" class="input-error" role="alert"
						*ngIf="INDRA_hasErrors(formOtherCard.get('first_name'))">
						{{ INDRA_formErrors(formOtherCard.get('first_name'), 'first_name') | ibeadmin | async }}
					</span>
				</div>
				<div class="form-field col-4 col-tp-6 col-p-12">
					<label class="label" for="last_name">
						{{ 'shoppingBasket.text.lastName' | ibeadmin | async }}
						<span class="description">
							{{ 'shoppingBasket.text.asAppearsOnCard' | ibeadmin | async }}
						</span>
					</label>
					<input 
						[placeholder]="'shoppingBasket.text.insertLastName' | ibeadmin | async" 
						class="input-text" 
						formControlName="last_name" 
						id="last_name" 
						[ngClass]="INDRA_hasErrorsClasses(formOtherCard.get('last_name'))" 
						maxlength="32"/>
					<span aria-live="polite" class="input-error" role="alert"
						*ngIf="INDRA_hasErrors(formOtherCard.get('last_name'))">
						{{ INDRA_formErrors(formOtherCard.get('last_name'), 'last_name') | ibeadmin | async }}
					</span>
				</div>
			</div>
				
			<div class="form-field--row grid no-padding">
				<div class="form-field col-6 col-tp-6 col-p-12">
					<label class="label" for="card_number">
						{{ 'shoppingBasket.text.cardNumber' | ibeadmin | async }}
						<span class="description">
							{{ 'shoppingBasket.text.longNumber' | ibeadmin | async }}
						</span>
					</label>
					<input 
						[placeholder]="'shoppingBasket.text.insertCreditCard' | ibeadmin | async" 
						class="input-text" 
						formControlName="card_number" 
						id="card_number" 
						type="text"
						inputmode="numeric" 
						[ngClass]="INDRA_hasErrorsClasses(formOtherCard.get('card_number'))"
						size="19"
						maxlength="19"
						(blur)="INDRA_trimFieldValue($event, formOtherCard.get('card_number'))"
						[appNumberOnly]="'ext'" />
					<span aria-live="polite" class="input-error" role="alert"
						*ngIf="INDRA_hasErrors(formOtherCard.get('card_number'))">
						{{ INDRA_formErrors(formOtherCard.get('card_number'), 'card_number') | ibeadmin | async }}
					</span>
				</div>
				<div class="form-field col-4 col-tp-6 col-p-12" *ngIf="!cardWithoutCvc && type !== 'bancontact'">
					<label class="label" for="security_code">
						{{ 'shoppingBasket.text.securityCode' | ibeadmin | async }}
						<app-svg tooltip="{{'shoppingBasket.tooltip.securityCodeTooltip' | ibeadmin | async}}" 
							alt="{{'shoppingBasket.alt.securityCodeTooltip' | ibeadmin | async}}"
							svg="icons.svg#general--information" 
							[alt]="'bookingPayment.alt.informationIcon' | ibeadmin | async">
						</app-svg>
					</label>
					<div class="grid">
						<div class="col-5">
							<input 
								class="input-text" 
								formControlName="security_code" 
								type="text" 
								inputmode="numeric" 
								pattern="[0-9]*"
								id="security_code" 
								[ngClass]="{'has-error':!formOtherCard.controls.security_code.valid&&formOtherCard.controls.security_code.touched}" 
								pattern="\d*" size="4" maxlength="4" appNumberOnly />
						</div>
						<div class="col-7">
							<div class="payment-option-security-code-image__wrapper">
								<app-svg 
									svg="sprite.svg#credit_card--security_code_info" 
									class="payment-option-security-code-image"
									[alt]="'bookingPayment.alt.cardSecurityCode' | ibeadmin | async">
								</app-svg>
							</div>
						</div>
					</div>
					<span aria-live="polite" class="input-error" role="alert"
						*ngIf="INDRA_hasErrors(formOtherCard.get('security_code'))">
						{{ INDRA_formErrors(formOtherCard.get('security_code'),'security_code') | ibeadmin | async }}
					</span>
				</div>
			</div>
			
			<div class="form-field--row grid no-padding">
				<div class="form-field col-3 col-tp-6 col-p-12 payment-card-types-wrapper">
					<label class="label" for="expiration_date_month">
						{{ 'shoppingBasket.text.expirationDate' | ibeadmin | async }}
					</label>
					<div class="grid">
						<div class="col-6">
							<app-select-input-indra
								selectId="expiration_date_month--other-card"
								formControlName="expiration_date_month"
								[placeholder]="!(formOtherCard.get('expiration_date_month').value) ? 'mm' : null"
								[options]="intervalMonth"
								[optionsTranslated]="true"
								[errorClass]="INDRA_hasErrorsClasses(formOtherCard.get('expiration_date_month'))"
								(change)="INDRA_formChanges('otherForm_month')">
							</app-select-input-indra>
						</div>
						<div class="col-6">
							<app-select-input-indra
								selectId="expiration_date_year--other-card"
								formControlName="expiration_date_year"
								[placeholder]="!(formOtherCard.get('expiration_date_year').value) ? 'yy' : null"
								[options]="intervalYear"
								[optionsTranslated]="true"
								[errorClass]="INDRA_hasErrorsClasses(formOtherCard.get('expiration_date_year'))"
								(change)="INDRA_formChanges('otherForm_year')">
							</app-select-input-indra>
						</div>
					</div>
					<span aria-live="polite" class="input-error" role="alert"
						*ngIf="INDRA_hasErrors(formOtherCard.get('expiration_date_month')) || INDRA_hasErrors(formOtherCard.get('expiration_date_year'))">
						{{INDRA_formErrors(formOtherCard.get('expiration_date_month'), 'expiration_date_month') | ibeadmin | async}}
						{{INDRA_formErrors(formOtherCard.get('expiration_date_year'), 'expiration_date_year') | ibeadmin | async}}
					</span>
				</div>
			</div>
			
			<ng-container *ngIf="isAddressFieldsRequired">
				<div class="form-field--row grid no-padding">
					<div class="form-field col-8 col-tp-10 col-p-12">
						<label class="label" for="adress">
							{{ 'shoppingBasket.text.address' | ibeadmin | async }}
						</label>
						<input #addressInput
							maxlength="60"
							[placeholder]="'shoppingBasket.text.insertAddress' | ibeadmin | async" 
							class="input-text" 
							formControlName="adress" 
							id="adress"
							[ngClass]="INDRA_hasErrorsClasses(formOtherCard.get('adress'))" />
						<span aria-live="polite" class="input-error" role="alert"
							*ngIf="INDRA_hasErrors(formOtherCard.get('adress'))">
							{{ INDRA_formErrors(formOtherCard.get('adress'), 'adress') | ibeadmin | async }}
						</span>
					</div>
				</div>

				<div class="form-field--row grid no-padding">
					<div class="form-field col-4 col-tp-4 col-p-12">
						<label class="label" for="zip_code">
							{{ 'shoppingBasket.text.zipCode' | ibeadmin | async }}
						</label>
						<input #zipCodeInput
							[placeholder]="'shoppingBasket.text.insertZipCode' | ibeadmin | async"
							class="input-text" 
							formControlName="zip_code" 
							id="zip_code"
							maxlength="10"
							[ngClass]="INDRA_hasErrorsClasses(formOtherCard.get('zip_code'))" />
						<span aria-live="polite" class="input-error" role="alert"
							*ngIf="INDRA_hasErrors(formOtherCard.get('zip_code'))">
							{{ INDRA_formErrors(formOtherCard.get('zip_code'), 'zip_code') | ibeadmin | async }}
						</span>
					</div>
					<div class="form-field col-4 col-tp-8 col-p-12">
						<label class="label" for="city">{{ 'shoppingBasket.text.city' | ibeadmin | async }}</label>
						<input #cityInput 
							[placeholder]="'shoppingBasket.text.insertCity' | ibeadmin | async" 
							class="input-text" 
							formControlName="city" 
							id="city" 
							type="text"
							(keypress)="!INDRA_numericOnly($event)"
							[ngClass]="INDRA_hasErrorsClasses(formOtherCard.get('city'))"
							appTextWithoutNumbersDirective />
						<span aria-live="polite" class="input-error" role="alert"
							*ngIf="INDRA_hasErrors(formOtherCard.get('city'))">
							{{ INDRA_formErrors(formOtherCard.get('city'), 'city') | ibeadmin | async }}
						</span>
					</div>
				</div>
			</ng-container>
			
			<div class="form-field--row grid no-padding">
				<ng-container *ngIf="isAddressFieldsRequired">
					<div class="form-field col-4 col-tp-8 col-p-12">
						<app-select-input-indra
							formControlName="country"
							[label]="'shoppingBasket.text.country' | ibeadmin | async"
							(selectionChanged)="INDRA_formChanges($event)"
							[placeholder]="!(formOtherCard.get('country').value) ? ('shoppingBasket.text.selectCountry' | ibeadmin | async) : null"
							[options]="countryCodes"
							[optionsTranslated]="true"
							[errorClass]="INDRA_hasErrorsClasses(formOtherCard.get('country'))"
						></app-select-input-indra>
						<span aria-live="polite" class="input-error" role="alert"
							*ngIf="INDRA_hasErrors(formOtherCard.get('country'))">
							{{ INDRA_formErrors(formOtherCard.get('country'), 'country') | ibeadmin | async }}
						</span>
					</div>
					<div class="form-field col-4 col-tp-8 col-p-12" *ngIf ="showStateField">
						<app-select-input-indra
							formControlName="state"
							[label]="'shoppingBasket.text.state' | ibeadmin | async"
							(selectionChanged)="INDRA_formChanges('newState')"
							[placeholder]="!(formOtherCard.get('state').value) ? ('shoppingBasket.text.selectState' | ibeadmin | async) : null"
							[options]="stateOptions"
							[optionsTranslated]="true"
							[errorClass]="INDRA_hasErrorsClasses(formOtherCard.get('state'))"
						></app-select-input-indra>
						<span aria-live="polite" class="input-error" role="alert"
							*ngIf="INDRA_hasErrors(formOtherCard.get('state'))">
							{{ INDRA_formErrors(formOtherCard.get('state'), 'state') | ibeadmin | async }}
						</span>
					</div>
				</ng-container>
				
				<div class="form-field col-12" *ngIf="userInfo && type != 'bancontact' && isOCP">
					<div class="payment-option__save-card">
						<app-checkbox-input [label]="''" formControlName="save_card" (change)="INDRA_formChanges('save_card')">
						</app-checkbox-input>
						<span>	{{ 'bookingPayment.text.saveForFuture' | ibeadmin | async }}</span>
					</div>
				</div>

				<div class="form-field col-12 payment-option__conditions-wrapper" [class.has-error]="!acceptedTermsAndConditions">
					<ng-container *ngIf="hasHotelRoom && type === 'credit'">
						<div class="payment-option__conditions bottom-gap">
							<app-checkbox-input 
								[label]="''" 
								formControlName="accepted_send_user_info"
								(change)="INDRA_acceptedHotelConditionChange('acceptedHotelConditionOther')" 
								[checked]="acceptedHotelConditionOther"
								[class.has-error]="INDRA_hasErrors(formOtherCard.get('accepted_send_user_info'))">
							</app-checkbox-input>
							<span>
								{{ 'bookingPayment.text.iUnderstand' | ibeadmin | async }}
							</span>
						</div>
						<span aria-live="polite" class="input-error display--block" role="alert"
							*ngIf="INDRA_hasErrors(formOtherCard.get('accepted_send_user_info'))">
							{{ INDRA_formErrors(formOtherCard.get('accepted_send_user_info'), 'accepted_send_user_info') | ibeadmin | async }}
						</span>
					</ng-container>
				
					<div class="payment-option__conditions">
						<app-checkbox-input 
							[label]="''" 
							(change)="INDRA_acceptedConditionChange($event, 'acceptedConditionOther')" 
							[checked]="acceptedConditionOther"
							formControlName="accepted_conditions" 
							[class.has-error]="INDRA_hasErrors(formOtherCard.get('accepted_conditions'))">
						</app-checkbox-input>
						<span>
							{{ 'shoppingBasket.text.fullAndAccept' | ibeadmin | async }} 
							<a class="link" href="javascript:;"
								(click)="INDRA_handleBookingTicketConditions()" 
								[attr.aria-label]="'bookingPayment.aria.openFare' | ibeadmin | async" role="button">
								{{ 'shoppingBasket.text.fareCondition' | ibeadmin | async }}
							</a> 
							{{ 'bookingPayment.text.andThe' | ibeadmin | async }}
							<a class="link link--external" href="javascript:;"
								(click)="INDRA_gotoURL('externalURLs.transportConditions')"
								[attr.aria-label]="'bookingPayment.text.conditionsOfCarriage' | ibeadmin | async">
								{{ 'shoppingBasket.text.termsConditionCarriage' | ibeadmin | async }}
							</a> 
							<!--{{ 'bookingPayment.text.andThe' | ibeadmin | async }}
							<a class="link link--external" href="javascript:;"
								(click)="INDRA_gotoURL('externalURLs.milesGoTermsConditions')"
								[attr.aria-label]="'bookingPayment.text.conditionsOfMilesGo' | ibeadmin | async">
								{{ 'bookingPayment.text.conditionsOfMilesGoProgramme' | ibeadmin | async }}
							</a>-->
							<ng-container *ngIf="displayCovidTermsAndCondition">
								, {{ 'bookingPayment.text.andAcceptCovidCondition' | ibeadmin | async }}
								<a class="link link--external" href="javascript:;"
									(click)="INDRA_gotoURL('externalURLs.canadaTravelMeasures')">
									{{ 'bookingPayment.text.termsConditions' | ibeadmin | async }}
								</a>
								{{ 'bookingPayment.text.covidCondition' | ibeadmin | async }}
							</ng-container>
						</span>
					</div>
					<span aria-live="polite" class="input-error display--block" role="alert"
						*ngIf="INDRA_hasErrors(formOtherCard.get('accepted_conditions'))">
						{{ INDRA_formErrors(formOtherCard.get('accepted_conditions'), 'accepted_conditions') | ibeadmin | async }}
					</span>
				</div>
			</div>
		</fieldset>
	</form>
</ng-container>

<ng-container *ngIf="selectedCardType == null || selectedCardType == undefined">
	<app-notification class="cc-surcharge-notification" [style]="'note'" [icon]="'icons.svg#general--information'" *ngIf="(type === 'credit') && surchargeDisplay > 0">
		<div message>
			<span>
				{{ 'bookingPayment.text.creditCardSurchargeMsg1' | ibeadmin | async }} {{surchargeDisplay}}% {{ 'bookingPayment.text.creditCardSurchargeMsg2' | ibeadmin | async }} 
			</span>
		</div>
	</app-notification>
</ng-container>
